import clientAxios from './../../config/axios';

export const getAllProperties = ({ filter, pagination }: any) => {
  const filterTmp = filter ?? '';
  const complement = pagination.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/properties?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  return clientAxios.get(url);
};

export const getPropertyByNid = ({ nid }: { nid: string }) => {
  const complement = `all=1&nid=${nid}`;
  const url = `/properties?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  return clientAxios.get(url);
};

export const updateProperty = (property: any) => {
  const url = `/properties?country=${process.env.REACT_APP_ENV_COUNTRY}&id=${property.nid}`;
  return clientAxios.put(url, property);
};

export const createProperty = (property: any) => {
  const url = `/properties`;
  return clientAxios.post(url, property);
};

export const getProblems = () => {
  const url = `/problems/?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  return clientAxios.get(url);
};
